import { batch } from 'react-redux';
import mime from 'mime';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';

// Keeps every entity import on the same request and download contract as Client.
const createImportApi = ({ actions, capabilities, endpoint, templateFileName }) => {
    const reportError = (error, errorCallback) => {
        const errorMsg = errorProcessor(error?.response?.data);

        if (capabilities.app.includes('error-logger')) {
            dispatch(actions.logError(errorMsg));
        }
        if (typeof errorCallback === 'function') {
            errorCallback(errorMsg);
        }
    };

    return {
        importCollection: async ({ file, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
            if (capabilities.app.includes('importer')) {
                dispatch(actions.startImporting());
            }

            const formData = new FormData();
            formData.append('file', file);

            await gestopAPI
                .post(`${endpoint}/import`, formData, config)
                .then((response) =>
                    batch(() => {
                        if (capabilities.app.includes('importer')) {
                            dispatch(actions.stopImporting());
                        }
                        successCallback(response?.data);
                    })
                )
                .catch((error) =>
                    batch(() => {
                        if (capabilities.app.includes('importer')) {
                            dispatch(actions.stopImporting());
                        }
                        reportError(error, errorCallback);
                    })
                );
        },
        downloadImportModel: async ({ successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
            if (capabilities.app.includes('exporter')) {
                dispatch(actions.startExporting());
            }

            await gestopAPI
                .get(`${endpoint}/getimporttpl`, { ...config, responseType: 'blob' })
                .then((response) =>
                    batch(() => {
                        const blob = new Blob([response.data], { type: response.headers['content-type'] });
                        const href = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        const fileExt = mime.getExtension(response.headers['content-type']);

                        link.href = href;
                        link.setAttribute('download', `${templateFileName}${fileExt ? `.${fileExt}` : ''}`);
                        link.style.display = 'none';
                        link.click();
                        URL.revokeObjectURL(href);

                        if (capabilities.app.includes('exporter')) {
                            dispatch(actions.stopExporting());
                        }
                        successCallback(response?.data);
                    })
                )
                .catch((error) =>
                    batch(() => {
                        if (capabilities.app.includes('exporter')) {
                            dispatch(actions.stopExporting());
                        }
                        reportError(error, errorCallback);
                    })
                );
        }
    };
};

export default createImportApi;
